/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGroupEmergencyEmailLanguageRequest
 */
export interface UpdateGroupEmergencyEmailLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEmergencyEmailLanguageRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEmergencyEmailLanguageRequest
     */
    group_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEmergencyEmailLanguageRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEmergencyEmailLanguageRequest
     */
    language_code: string;
}

/**
 * Check if a given object implements the UpdateGroupEmergencyEmailLanguageRequest interface.
 */
export function instanceOfUpdateGroupEmergencyEmailLanguageRequest(value: object): value is UpdateGroupEmergencyEmailLanguageRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function UpdateGroupEmergencyEmailLanguageRequestFromJSON(json: any): UpdateGroupEmergencyEmailLanguageRequest {
    return UpdateGroupEmergencyEmailLanguageRequestFromJSONTyped(json, false);
}

export function UpdateGroupEmergencyEmailLanguageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroupEmergencyEmailLanguageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_id': json['group_id'],
        'email': json['email'],
        'language_code': json['language_code'],
    };
}

export function UpdateGroupEmergencyEmailLanguageRequestToJSON(json: any): UpdateGroupEmergencyEmailLanguageRequest {
    return UpdateGroupEmergencyEmailLanguageRequestToJSONTyped(json, false);
}

export function UpdateGroupEmergencyEmailLanguageRequestToJSONTyped(value?: UpdateGroupEmergencyEmailLanguageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'email': value['email'],
        'language_code': value['language_code'],
    };
}

